<!--
 * @Description: 
 * @Autor: Ray7hw
 * @LastEditTime: 2020-10-20 14:45:28
-->
<template>
  <div class="singup">
    <div class="singup-c">
      <div class="singup-t">华中文交所报名及结算系统</div>

      <div class="singup-b">
        <div class="singup-1">
          <div class="singup-1-l">注册类型：</div>
          <div
            style="display:flex;margin:0 54px 0 30px;"
            @click="change(1)"
          >
            <div
              class="icon iconfont "
              :class="[flag==1?'icon-xuanzhong':'icon-weixuanzhong',flag==1?'singup-1-r3':'singup-1-r']"
            ></div>
            <div class="singup-1-r1">个人注册</div>
          </div>
          <div
            style="display:flex"
            @click="change(2)"
          >
            <div
              class="icon iconfont "
              :class="[flag==2?'icon-xuanzhong':'icon-weixuanzhong',flag==2?'singup-1-r3 ':'singup-1-r ']"
            ></div>
            <div class="singup-1-r2">法人/其他组织/个体工商户注册</div>
          </div>

        </div>
        <div
          class="singup-2"
          v-show="flag ==1"
        >

          <div>

            <el-form
              label-width="350px"
              :rules="rules"
              :model="form"
             
            >

              <el-form-item
                label="用户名:"
                prop="userName"
              >
                <el-input
                  
                  v-model="form.userName"
                  @blur="changename1"
                
                  placeholder="支持英文、数字的组合，6-16个字符"
                ></el-input>
                <div
                  style="color:#F56C6C;font-size:12px"
                  v-if="yzflag3==1"
                >{{nameMassage}}</div>
              </el-form-item>

              <el-form-item
                label="密码:"
                prop="password"
              >
                <el-input
                  :disabled="yz1"
                  type='password'
                  v-model="form.password"
                  placeholder="使用字母、数字和符号2种以上,6-20字符"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="确认密码:"
                prop="ispassword"
              >
                <el-input
                :disabled="yz2"
                  type='password'
                  v-model="form.ispassword"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="真实姓名:"
                prop="realName"
              >
                <el-input
                 :disabled="yz20"
                 v-model="form.realName"></el-input>
              </el-form-item>
              <el-form-item
                label="我的身份证号码:"
                prop="id_card"
              >
                <el-input
                    :disabled="yz3"
                  v-model="form.id_card"
                  @blur="changename2"
                  maxlength="18"
                ></el-input>

                <div
                  style="color:#F56C6C;font-size:12px"
                  v-show="yzflag1==1"
                >{{nameMassage1}}</div>
              </el-form-item>

              <!-- <div class="hd"></div> -->
              <el-form-item
                label="我的身份证正反面照片:"
                class="tuys"
                prop="photo1"
              >
                <!-- <el-input
                  v-model="form.id_card"
                  @blur="changename2"
                  maxlength="18"
                ></el-input> -->
                <div class="wz">
                  *不超过10MB
                </div>
              </el-form-item>

              <el-form-item
                label="我的身份证正反面照片:"
                class="tuys-b-wz"
                prop="photo2"
              >
                <div class="tuys-b-hz">
                  <div class="img1">
                    <el-upload
                      :class="{hide:hideUpload1}"
                      :action="url"
                      list-type="picture-card"
                      :limit="1"
                      :on-success="handleAvatarSuccess1"
                      :on-preview="handlePictureCardPreview1"
                      :on-remove="handleRemove1"
                      :data="data"
                      :on-change='change1'
                      v-if="yinc !=1"
                      on-progress="progress"
                    >
                      <img
                        style="width: 120px;
                          height: 100px;margin-top:20px"
                        src="../../assets/images/card.png"
                        alt=""
                      >
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible1">
                      <img
                        width="100%"
                        :src="imageUrl1"
                        alt=""
                      >
                    </el-dialog>

                  </div>

                  <div
                    class="img1 img2"
                    v-if="yinc !=1"
                  >
                    <el-upload
                      :class="{hide:hideUpload2}"
                      :action="url"
                      list-type="picture-card"
                      :limit="1"
                      :on-success="handleAvatarSuccess2"
                      :on-preview="handlePictureCardPreview2"
                      :on-remove="handleRemove2"
                      on-progress="progress"
                      :data="data"
                      :on-change='change2'
                    >
                      <img
                        style="width: 120px; height: 100px;margin-top:20px"
                        src="../../assets/images/card1.png"
                        alt=""
                      >
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible2">
                      <img
                        width="100%"
                        :src="imageUrl2"
                        alt=""
                      >
                    </el-dialog>
                  </div>

                </div>
                <!-- <el-input  v-model="form.name8"></el-input> -->

              </el-form-item>

              <el-form-item
                label="我的手机号:"
                class="sfz"
                prop="phone"
              >

                <el-input
                    :disabled="yz4"
                  v-model="form.phone"
                  @input="changename3"
                  maxlength="11"
                >

                </el-input>

                <div style="margin-left: 5px;">
                  <el-button @click="add">{{gety}}</el-button>
                </div>

              </el-form-item>

              <div
                style="color:#F56C6C;font-size: 12px;
                         margin-left: 36%;
                          margin-top: -18px;
                           box-sizing: border-box;
                           height: 22px;"
                v-show="yzflag2==1"
              >{{nameMassage2}}</div>

              <!-- <div style="color:#F56C6C;font-size:12px;margin-right:33%;margin-top:-19px"> </div> -->
              <el-form-item
                label="验证码:"
                prop="yzm1"
                v-if="yzflag == 1"
              >
                <el-input
                    :disabled="yz5"
                  v-model="form.yzm1"
                  @keyup.enter="submit"
                ></el-input>
              </el-form-item>

              <el-form-item class="tjan">
                <div class="tjan-hz">
                  <el-button
                    type="primary"
                    @click="submit"
                  >提交</el-button>
                  <el-button @click="enterlogin">返回</el-button>
                </div>

              </el-form-item>

            </el-form>

            <el-dialog
              title="提示"
              :visible.sync="dialogVisiblehqyam"
              width="30%"
              :before-close="handleClose"
              class="dialog"
            >
              <div>

                <div class="login-c-2">
                  <div class="login-i">
                    <el-input
                      prefix-icon="iconfont icon-yanzhengma"
                      v-model="form.yzm"
                      placeholder="请输入验证码"
                      @blur="changyzm"
                    > </el-input>
                  </div>

                  <div>
                    <s-identify :identifyCode="identifyCode"></s-identify>
                  </div>
                  <div
                    class="login-code"
                    @click="refreshCode"
                  >换一张</div>
                </div>

              </div>
              <span
                slot="footer"
                class="dialog-footer"
              >
                <el-button @click="quxiao">取 消</el-button>
                <el-button
                  type="primary"
                  @click="getyzm"
                >确 定</el-button>
              </span>
            </el-dialog>

          </div>
        </div>
        <div
          class="singup-2"
          v-show="flag ==2"
        >

          <legalPerson :flag="flag"></legalPerson>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import SIdentify from '@/components/s-identify'
import legalPerson from './legalPerson'
// import { isDecimal, validatePsdReg, validatePhone, user_name, validateIdNo } from '../../../config/validate.js'
export default {
  components: {
    legalPerson: legalPerson,
    SIdentify
  },
  
  data () {
  
//用户名正则
let reg = /^([a-zA-Z0-9]){6,20}$/
var user_name = (rule, value, callback) => {
if (!reg.test(value))
 {  if(value===''){ callback(new Error('请输入用户名'))
     this.yz1=1;
             this.yz2=1;
              this.yz20=1;
              this.yz3=1;
               this.yz4=1;
                 

 }  else{
            callback(new Error('请输入英文、数字的组合，6-20个字符'))
           //alert("支持英文、数字的组合，6-16个字符")
            this.yz1=1;
             this.yz2=1;
              this.yz20=1;
              this.yz3=1;
               this.yz4=1;
                 
        }}
         else {
               this.yz1=0;
               this.yz2=0;
                this.yz20=0;
               this.yz3=0;
               this.yz4=0;
       }
        
   };


   //密码正则
   let mima = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/
   var validatePsdReg = (rule, value, callback) => {

  if (!mima.test(value)) { if(value===''){   callback(new Error('请输入密码'))
     this.yz2=1;
             this.yz20=1;
             this.yz3=1;
             this.yz4=1;
                
  }else{
            callback(new Error('请使用字母、数字和符号两种或两种以上,6-20字符之间'))
           //alert("支持英文、数字的组合，6-16个字符")
             this.yz2=1;
             this.yz20=1;
             this.yz3=1;
             this.yz4=1;
                
        } }else { 
               this.yz2=0;
              this.yz20=0;
               this.yz3=0;
               this.yz4=0;
               
               
        }
   };
   //再次密码
      let zcmima = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/
    var validatePass2= (rule, value, callback) => {
       if (!zcmima.test(value)) { if(value===''){   callback(new Error('请再次输入密码'))
     
             this.yz20=1;
             this.yz3=1;
             this.yz4=1;
                
  }else if(value!==this.form.password){
            callback(new Error('两次输入的密码不一致'))
           //alert("支持英文、数字的组合，6-16个字符")
            
             this.yz20=1;
            
             this.yz3=1;
             this.yz4=1;
                
        } }else { 
               
              this.yz20=0;
               this.yz3=0;
               this.yz4=0;
               
               
        }
   };
       var zsxm = (rule, value, callback) => { 
      if (value === '') {
        callback(new Error('请输入真实姓名'))
        this.yz3=1;
         this.yz4=1;
        

      }  else {
        callback();
         this.yz3=0;
         this.yz4=0;
      }
    };
let sfzh1=/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
var sfzh=(rule, value, callback) => {     if (!sfzh1.test(value)) { if(value===''){   callback(new Error('请输入身份证号'))
    this.yz4=1;
                 } else{callback(new Error('请输入正确的身份证号'))
  
               this.yz4=1;
  }}else { 
           this.yz4=0;
          
        }};

    return {
      data: {
        attach_type: '',
      },
      yz1:0,
       yz2:0,
        yz20:0,
       yz3:0,
        yz4:0,
      
      yinc: '',
      url: '',
      yzflag3: 0,
      nameMassage: '',
      yzflag1: 0,
      nameMassage1: '',
      yzflag2: 0,
      nameMassage2: '',
      dialogVisiblehqyam: false,

      hideUpload2: false,
      dialogVisible2: false,
      imageUrl2: '',
      hideUpload1: false,
      dialogVisible1: false,
      imageUrl1: '',

      flag: 1,
      labelPosition: 'right',

      form: {
        userName: '',
        password: '',
        ispassword: '',
        realName: '',
        organizer: '华中文交所',
        id_card: '',
        phone: '',
        yzm: '',
        yzm1: '',

      },
      fileInfo: [],
      userType: 1,
      isProtocol: 0,
      imageUrl1_id: '',
      imageUrl2_id: '',



      rules: {
        userName: [
         // { required: true, message: '请输入用户名', trigger: 'blur' },
         // { pattern: /^([a-zA-Z0-9]){6,20}$/, message: '支持英文、数字的组合，6-16个字符', trigger: 'blur'}
        

          { required: true, validator: user_name, trigger: 'blur' }
        ],
        password: [
         // { required: true, message: '请输入密码', trigger: 'blur' },
          //{ pattern: /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/, message: '请使用字母、数字和符号两种或两种以上,6-20字符之间', trigger: 'blur' }
           { required: true, validator: validatePsdReg, trigger: 'blur' }
        ],
        ispassword: [
         // { required: true, message: '请输入确认密码', trigger: 'blur' },
         // { pattern: /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/, message: '请使用字母、数字和符号两种或两种以上,6-20字符之间', trigger: 'blur' },

          { required: true, validator: validatePass2, trigger: 'blur' }
        ],
        realName: [
        
            { required: true, validator: zsxm, trigger: 'blur' }
        ],
        id_card: [
         // { required: true, message: '请输入身份证号', trigger: 'blur' },
          //  { validator: validateIdNo, trigger: 'blur' }
        //  { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号', trigger: 'blur' }
          { required: true, validator: sfzh, trigger: 'blur' }

        ],
        photo1: [{ required: true, message: '请上传证件', trigger: 'blur' }],
        // { validator: validatePhone, trigger: 'blur' }
        // { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入11位的手机号', trigger: 'change' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          // { validator: validatePhone, trigger: 'blur' }
          { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入11位的手机号', trigger: 'change' }

        ],
        yzm: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        yzm1: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],



      },
     
      yzm: '',
      identifyCode: '',
      identifyCodes: '1234567890',
      yzflag: 0,
      yzm2: '',
      times: 60,
      gety: '获取验证码',
      stop: 1,
      phone1: '',
      phone2: '',
      aa: 1,
      // userType: '',
      isOk:true

    };
  },
  
  created () {
    let isp = localStorage.getItem('flag')

  //  let isp = this.$route.query.flag

    console.log(isp, "接受的参数");
    if (isp == 1) {
      this.isProtocol = isp

    } else {
      this.$router.push('/Protocol')
    }

    var lett = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        lett.submit();
      }
    }


    console.log(this.$url, 98)
    this.url = this.$url + 'up/uploadAttach.do'
    this.createCode()


  },
  mounted () { },
  methods: {



    //鼠标移出input
    changename1 () {
      let form = new FormData()
      form.append('userType', this.userType)
      form.append('userName', this.form.userName)
      this.$axios.post("user/verifyUser.do", form).then(res => {
        if (res.data.code == 200) {
          this.nameMassage = res.data.data
          
          this.yzflag3 = 1
          
        }
      

        console.log(res, 66)
        // console.log(this.rules.userName[0].message, 66)
      })
      // this.rules[0].userName[0].message = res.date.data.message


    },


    //身份证去重
    changename2 () {
      let form = new FormData()
      form.append('userType', this.userType)
      form.append('idcard', this.form.id_card)
      this.$axios.post("user/verifyUser.do", form).then(res => {
        if (res.data.code == 200) {
          this.nameMassage1 = res.data.data
          this.yzflag1 = 1
        }

        console.log(res, 66)
        // console.log(this.rules.userName[0].message, 66)
      })
      // this.rules[0].userName[0].message = res.date.data.message


    },

    //手机号去重
    changename3 () {


      // console.log(this.phone2, 9998)
      console.log(this.aa, 99999)
      let form = new FormData()
      form.append('userType', this.userType)
      form.append('phone', this.form.phone)
      this.$axios.post("user/verifyUser.do", form).then(res => {
        if (res.data.code == 200) {
          this.nameMassage2 = res.data.data

          this.yzflag2 = 1
          this.phone2 = this.form.phone
          // console.log(this.phone2, 9888765)
          if (res.data.data == '') {
            this.yzflag2 = 0
          }

        }

        console.log(res, 66)
        // console.log(this.rules.userName[0].message, 66)
      })
      // this.rules[0].userName[0].message = res.date.data.message


    },

    //获取验证码
    changyzm () {
      localStorage.setItem('yzm1', this.form.yzm1)


      // console.log(this.phone1, 98888)
    },


    createCode () {
      var code = '';
      //设置长度，这里看需求，我这里设置了4
      var codeLength = 4;

      //设置随机字符
      var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);

      //循环codeLength 我设置的4就是循环4次
      for (var i = 0; i < codeLength; i++) {
        //设置随机数范围,这设置为0 ~ 36
        var index = Math.floor(Math.random() * 9);

        //字符串拼接 将每次随机的字符 进行拼接
        code += random[index];
      }

      //将拼接好的字符串赋值给展示的code
      this.identifyCode = code;
    },


    handleClose () {
      this.dialogVisiblehqyam = false
    },

    add () {


      var papattern = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      if (this.stop != 2) {
        if (this.form.phone != '') {
          this.dialogVisiblehqyam = true
        } else {
          this.$message.error('手机号为空，请填写');
        }
        if (this.yzflag2 != 0) {
          this.dialogVisiblehqyam = false
          this.$message.error('手机号重复，请重新填写');
        }

        if (!papattern.test(this.form.phone)) {
          this.dialogVisiblehqyam = false
          this.$message.error('手机号格式错误，请重新填写');
        }
        this.createCode()

      }






    },
    getyzm () {


      if (this.form.yzm != this.identifyCode) {
        this.$message.error('验证码填写错误，请重新填写！');
        return
      } else {
        this.yzflag = 1
        console.log(99)
        let form = new FormData();
        form.append('phone', this.form.phone)
        this.$axios.post("user/phoneVerification.do", form).then(res => {
          this.createCode()
          this.dialogVisiblehqyam = false
          this.yzm2 = res.data.data
          // this.form.yzm = 
          this.form.yzm = ''

          localStorage.setItem('phone', this.form.phone)
          this.phone1 = localStorage.getItem('phone')
          console.log(this.phone1, 9999999)
          console.log(res, 66)
          let timeid = setInterval(() => {
            this.times--
            // console.log(this.times, 98989898)
            this.stop = 2
            this.gety = this.times + 's'
            if (this.times === 0) {
              this.stop = 1
              this.gety = '重新获取验证码'
           

              // this.show = true

              clearInterval(timeid)
              this.times = 60
              // this.$router.push('/layout/projectRegistration')
            }
          }, 1000)

        })
      }


    },
    quxiao () {
      // this.createCode()
      this.dialogVisiblehqyam = false
      this.form.yzm = ''
    },
    submit () {

      // console.log(this.phone1, this.phone2, " =============")

      if(!this.isOk) return
      if (this.form.password != this.form.ispassword) {
        this.$message.error('密码不一致，请确认后重新输入');
        return
      }



      if (this.form.userName == '') {
        this.$message.error('用户名不能为空！请先填写！');
        return
      }
      if (this.form.password == '') {
        this.$message.error('密码不能为空！请先填写！');
        return
      }
      if (this.form.ispassword == '') {
        this.$message.error('确认密码不能为空！请先填写！');
        return
      }
      if (this.form.realName == '') {
        this.$message.error('真实姓名不能为空！请先填写！');
        return
      }
      if (this.form.id_card == '') {
        this.$message.error('身份证号不能为空！请先填写！');
        return
      }
      if (this.form.phone == '') {
        this.$message.error('手机号不能为空！请先填写！');
        return
      }
      if (this.form.yzm1 != this.yzm2) {
        this.$message.error('验证码错误！请重新填写');
        return
      }
      // console.log(this.phone1, this.phone2, 99999)
      if (this.phone1 != this.phone2) {
        this.$message.error('手机号和获取的验证码不一致！请重新获取验证码');
        return
      }


      if (this.form.yzm1 == '') {
        this.$message.error('验证码不能为空！请先获取验证码！');
        return
      }
      if (this.imageUrl1_id == '') {
        this.$message.error('请上传身份证头像照片！')
        return
      }
      if (this.imageUrl2_id == '') {
        this.$message.error('请上传身份证国徽照片！')
        return
      }
      let userName = this.form.userName
      let password = this.form.password
      let ispassword = this.form.ispassword
      let realName = this.form.realName
      let organizer = this.form.organizer
      let id_card = this.form.id_card
      let yzm = this.form.yzm
      let userType = this.userType
      let isProtocol = this.form.isProtocol
      let phone = this.form.phone

      let url_id = this.fileInfo.toString()

      let form = new FormData()
      form.append('userName', userName)
      form.append('password', password)
      form.append('organizer', organizer)
      form.append('trueName', realName)
      form.append('phone', phone)
      form.append('idcard', id_card)
      form.append('pic', url_id)
      form.append('userType', userType)
      form.append('isProtocol', this.isProtocol)
      form.append('space_ename', 'whcq')
      // space_ename='whcq '
      this.isOk = false
      this.$axios.post('user/addUser.do', form).then(res => {

        this.createCode()
        if (res.data.code == '000') {
          this.$message({
            message: res.data.message,
            type: 'warning'

          });
          this.isOk = true
          return
        }
        if (res.data.code == 200) {
          this.$alert('注册成功,请登录。', {
            confirmButtonText: '确定',
            title: '提示',
            callback: action => {
              this.isOk = true
              this.$router.push('/login')
            }
          });
        }
        console.log(res, 99)

        // this.$message.success('注册成功！请登录')



      })


    },

    refreshCode () {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ]
      }
    },
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },



    change (flag) {
      // console.log(flag, 88)
      this.flag = flag
      this.userType = flag


    },
    change1 (file) {
      console.log(file, 99)
      this.data.attach_type = 1
    },
    change2 (file) {
      console.log(file, 99)
      this.data.attach_type = 2
    },


    handleAvatarSuccess2 (res, file) {
      this.imgType = 2
      console.log(file, 77)
      // this.imageUrl2 = URL.createObjectURL(file.raw);
      this.imageUrl2 = file.response.data.fileInfo[0].src
      this.imageUrl2_id = file.response.data.fileInfo[0].attach_id
      this.attach_type = file.response.data.fileInfo[0].attach_type
      this.fileInfo.push(this.imageUrl2_id)
      // this.imageUrl2_id = ''
      console.log(this.imageUrl2, 77)
      this.hideUpload2 = 1;
    },



    handleRemove2 (file, fileList) {
      this.hideUpload2 = 0;
      let form = new FormData
      form.append('attach_id', file.response.data.fileInfo[0].attach_id)
      this.$axios.post('up/delAttachInfo.do', form).then(res => {
        console.log(file, fileList);
        this.fileInfo = this.remove(this.fileInfo, file.response.data.fileInfo[0].attach_id)
        this.imageUrl2_id = ''
      })

    },
    handlePictureCardPreview2 (file) {
      // this.dialogImageUrl = file.url;
      this.dialogVisible2 = true;
    },

    progress () {
      this.yinc = 1
    },



    handleAvatarSuccess1 (res, file) {
      console.log(file, 77)
      this.imageUrl1 = file.response.data.fileInfo[0].src
      this.imageUrl1_id = file.response.data.fileInfo[0].attach_id
      this.fileInfo.push(this.imageUrl1_id)
      // this.attach_type 
      // this.imageUrl1 = URL.createObjectURL(file.raw);
      console.log(this.imageUrl1, 77)
      // this.imageUrl1_id = ''
      this.hideUpload1 = 1;
    },



    handleRemove1 (file, fileList) {
      this.hideUpload1 = 0;
      let form = new FormData
      form.append('attach_id', file.response.data.fileInfo[0].attach_id)
      this.$axios.post('up/delAttachInfo.do', form).then(res => {
        this.fileInfo = this.remove(this.fileInfo, file.response.data.fileInfo[0].attach_id)
        this.imageUrl1_id = ''
      })
      console.log(file, fileList);

    },
    handlePictureCardPreview1 (file) {
      // this.dialogImageUrl = file.url;
      this.dialogVisible1 = true;
    },
    //返回
    enterlogin () {
      this.$router.push('/login')
    },


    //移出数组中的某一项
    remove (arr, item) {
      var result = [];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] != item) {
          result.push(arr[i]);
        }
      }
      return result;
    },

  }
};
</script>

<style lang="less" >
.tuys-b-wz {
  height: 147px !important;
}

.hide .el-upload--picture-card {
  display: none;
}
page {
  overflow: scroll;
}
.singup {
  .dialog {
    .login-c-2 {
      display: flex;
      justify-content: center;
      width: 100%;
      margin: 0 auto;
      .el-input__icon {
        color: #a30001;
      }
      .login-i {
        width: 31%;
      }
      .login-code {
        margin: 5px 0 0 5px;
        margin-left: 10px;
        line-height: 28px;
      }
      .login-code:hover {
        cursor: pointer;
      }
    }
  }
}
.singup {
  overflow: auto;
  // position: fixed;
  // top: 0;
  // left: 0;
  width: 100%;
  height: 100%;

  z-index: -10;
  zoom: 1;
  background-color: #fff;
  background: url("../../assets/images/bg.png") no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  .singup-c {
    padding-bottom: 20px;
    // width: 1002px;
    width: 67%;
    background-color: #fff;
    margin: 6% auto;
    // margin-top: 6%;
    .singup-t {
      font-size: 32px;
      color: #a30001;
      line-height: 32px;
      margin-bottom: 43px;
      padding-top: 66px;
      text-align: center;
    }
    .singup-b {
      .singup-1 {
        padding-left: 17px;
        margin: 0 auto;
        display: flex;
        margin-bottom: 2%;
        justify-content: center;
        .singup-1-l {
          font-size: 20px;
          color: #000000;
        }
        .singup-1-r {
          color: #898989;
          margin: 3px 7px 0 0;
        }
        .singup-1-r3 {
          margin: 3px 7px 0 0;
          color: #a30001;
        }
      }
      .singup-2 {
        width: 100%;

        margin: 0 auto;
        .el-form-item__label {
          font-size: 20px;
          color: #000000;
        }
        .el-form-item__content {
          width: 30%;
          line-height: 18px;
        }
        .sfz {
          .el-form-item__content {
            display: flex;
          }
        }
        .tuys {
          .wz {
            text-align: left;
            color: red;
            margin-top: 4%;
          }
        }
        .tuys-b-wz {
          .el-form-item__label {
            color: #fff;
          }
          .el-form-item__content {
            width: 60%;
            .tuys-b-hz {
              width: 100%;
              display: flex;
              justify-content: space-around;
              // .img1 {
              //   img {
              //     // width: 100px;
              //     // height: 100px;
              //   }
              // }
            }
          }
        }
        .tjan {
          .el-form-item__content {
            // margin-left: 100px !important;
            width: 100%;
            width: 60%;
            .tjan-hz {
              display: flex;
              justify-content: space-around;
              width: 70%;
              .el-button {
                padding: 12px 50px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/singup/index.vue